import React from 'react'
import { Login } from './Login'
import { Register } from './Register'

export const AuthTemplate = () => {
    //get path from url
    const path = window.location.pathname
    return (
        <>
            {path === '/login' || path === '/' ? <Login /> : <Register />}
        </>
    )
}
